module.exports = __webpack_public_path__ + "static/media/login-bg.808655e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/login-bg.jpg
// module id = 169
// module chunks = 0